const baseUrl = "PassportSignature";

export const updateSignatureUrl = () => `${baseUrl}/UploadSignature`;
